export const socialsData = {
  facebook: "https://www.facebook.com/tiwvidurpals",
  linkedIn: "https://www.linkedin.com/in/vidur-tiwari",
  github: "https://github.com/tiwvidurpals",
};
